module.exports = __webpack_public_path__ + "img/logo-livetubex.b0aeb6b8.svg";